import React, { Fragment } from 'react'
import { convertTimeToCurrentTimeZone, removeHtmlTags } from '../../helper'
import { AiFillStar, AiOutlineStar } from 'react-icons/ai'

const UserCard = ({ item, findIsStarred, toggleStar, userId, timezone }) => {
    return (
        <Fragment>
            <img
                className="chat_user_img"
                src={item.userId[0].profileImage ? item.userId[0].profileImage : require('../../assets/img/user.png')}
                alt=""
            />
            <div className="chat_user_info">
                <span>
                    {item?.userId[0]?.name}
                    {(item?.programId?.length > 0 && item?.programId[0]?.programName) && ` — ${item?.programId[0]?.programName}`}
                </span>
                {item?.scheduleDateTime && (
                    <b><small>
                        Schedule date:&nbsp;
                        <time>
                            <i>{convertTimeToCurrentTimeZone(item.scheduleDateTime, timezone, 'MMM Do, hh:mm a')}</i>
                        </time>
                    </small></b>
                )}
                <small>{removeHtmlTags(item.lastMessage)}</small>
            </div>

            {(!item?.scheduleDateTime && item.count) ? (
                <span className="chat_unread_badge">{item.count}</span>
            ) : null}

            <div className="chat_star_col">
                {!item?.scheduleDateTime ? (
                    <span onClick={(e) => toggleStar(e, item)} style={{ cursor: 'pointer' }}>
                        {findIsStarred(item, userId)
                            ? <AiFillStar color="#841f15" size={22} />
                            : <AiOutlineStar size={22} />}
                    </span>
                ) : (
                    <span onClick={(e) => toggleStar(e, item)} style={{ cursor: 'pointer' }}>
                        <i className="icon-delete" />
                    </span>
                )}
            </div>
        </Fragment>
    )
}

export default UserCard
